import Paginate from 'components/Paginate';
import TableError from 'components/TableError';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, Table, UncontrolledDropdown } from 'reactstrap';
import { SORT_VALUES_DATE } from 'utils/constants';
import { SMKLinks } from 'utils/links';
import Loader from '../../../components/Loader';
import { useRouter } from '../../../hooks/useRouter';
import { buildURL, printSerialNumbers } from '../../../utils/helper';
import { Divider } from '@material-ui/core';
import { toast } from 'react-toastify';

const SchoolClinicDoctors = ({ schoolClinicsDetails }) => {
  const router = useRouter();
  const { query } = router;

  const [doctorsList, setDoctorsList] = useState([]);
  const [doctorsPagination, setDoctorsPagination] = useState({});

  const [getDoctorsListRequest, { loading: getDoctorsListLoading }] = useRequest({
    url: '/doctor/admin/search',
    method: 'POST',
    onSuccess: (data) => {
      setDoctorsList(data?.results);
      setDoctorsPagination(data?.pagination);
    },
  });

  const handleChangePage = async (page) => {
    await getDoctorsListRequest({
      data: {
        page: page,
        size: 20,
        ...SORT_VALUES_DATE,
        healthFacility: {
          id: schoolClinicsDetails?.healthcareFacilityId,
        },
      },
    });
  };

  useEffect(() => {
    if (!isEmpty(schoolClinicsDetails)) {
      handleChangePage(1);
    }
  }, [schoolClinicsDetails]);

  const [saveDoctorAccessRequest, { loading: saveDoctorAccessLoading }] = useRequest({
    method: 'POST',
    onSuccess: async () => {
      await handleChangePage(1);
      toast.success('Access saved successfully');
    },
  });

  const [createUserRequest, { loading: createUserLoading }] = useRequest({
    method: 'POST',
    onSuccess: async () => {
      await handleChangePage(1);
      toast.success('User created successfully');
    },
  });

  const [updateDoctorsRequest, { loading: updateDoctorsLoading }] = useRequest({
    method: 'POST',
    onSuccess: async () => {
      await handleChangePage(1);
      toast.success('User created successfully');
    },
  });

  const handleUpdateDoctors = (data, key) => {
    if (data[key]) {
      updateDoctorsRequest({
        method: 'PUT',
        url: `/doctor/admin/${data?.id}`,
        body: {
          ...data,
          [key]: false,
        },
      });
    } else {
      updateDoctorsRequest({
        method: 'PUT',
        url: `/doctor/admin/${data?.id}`,
        body: {
          ...data,
          [key]: true,
        },
      });
    }
  };

  const handleCreateUser = async (elem) => {
    try {
      await createUserRequest({
        url: `/doctor/admin/${elem?.id}/create-user`,
      });
    } catch (err) {
      toast.error('Something went wrong!');
    }
  };

  const handleGiveAccesstoAll = async () => {
    try {
      await saveDoctorAccessRequest({
        url: `/school-clinic/admin/${query?.id}/doctor-student-access`,
      });
    } catch (err) {
      toast.error('Something went wrong!');
    }
  };

  return (
    <div className="mt-4">
      <Loader
        isActive={getDoctorsListLoading || createUserLoading || updateDoctorsLoading || saveDoctorAccessLoading}
      />

      <Row className="mb-2 align-items-center">
        <Col sm="4">
          <div className="search-box me-2 d-inline-block">
            <div className="position-relative font-bold">{doctorsPagination?.totalCount} Doctors Found</div>
          </div>
        </Col>
        <Col sm="8">
          <div className="text-sm-end mb-2">
            <Link
              replace
              className="btn btn-sm btn-success btn-rounded waves-effect waves-light me-3"
              to={`${SMKLinks.HEALTHCARE_MODULE_ADD_DOCTOR}?schoolClinic=true&healthcareFacilityId=${schoolClinicsDetails?.healthcareFacilityId}&schoolClinicId=${schoolClinicsDetails?.id}`}>
              <i className="mdi mdi-plus me-1" />
              Add Doctor
            </Link>

            <button
              type="button"
              className="btn btn-danger btn-sm rounded-pill"
              onClick={() => {
                handleGiveAccesstoAll();
              }}>
              <i className="mdi mdi-plus me-1" />
              Give Access
            </button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          <div className="table-responsive" style={{ minHeight: 300 }}>
            <Table className="project-list-table   table-centered table-borderless">
              <thead>
                <tr className="table-warning">
                  <th scope="col">S.No.</th>
                  <th scope="col">Name</th>
                  <th scope="col">PhoneNumber</th>
                  <th scope="col">Degree</th>
                  <th scope="col">Active</th>
                  <th scope="col">Deleted</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(doctorsList) ? (
                  doctorsList?.map((elem, index) => {
                    return (
                      <tr key={`doctor_${elem?.id}`} className={!elem?.active ? 'bg-danger' : ''}>
                        <td>{printSerialNumbers(doctorsPagination)[index]}</td>
                        <td>
                          <Link
                            to={buildURL(SMKLinks.HEALTHCARE_MODULE_DOCTOR_DETAILS, {
                              id: elem?.id,
                            })}>
                            {elem?.salutation} {elem?.firstName} {elem?.lastName}
                          </Link>
                          <br />
                          {elem?.email}
                        </td>
                        <td>{elem?.phoneNumber}</td>
                        <td>{elem?.degree}</td>
                        <td>
                          <Badge className={elem?.active ? 'bg-success' : 'bg-danger'}>
                            {elem?.active ? 'Yes' : 'No'}
                          </Badge>
                        </td>
                        <td>
                          <Badge className={elem?.deleted ? 'bg-success' : 'bg-danger'}>
                            {elem?.deleted ? 'Yes' : 'No'}
                          </Badge>
                        </td>
                        <td>
                          <td>
                            <UncontrolledDropdown>
                              <DropdownToggle href="#" className="card-drop " tag="i">
                                <i role="button" className="mdi mdi-dots-vertical font-size-18 " />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem onClick={() => handleUpdateDoctors(elem, 'active')}>
                                  <i
                                    className={`fas  ${
                                      elem?.active ? 'fa-ban text-danger' : 'fa-power-off text-success'
                                    }   m-1 pe-3`}
                                  />
                                  {elem?.active ? 'Disable' : 'Enable'}
                                </DropdownItem>
                                {/* <DropdownItem onClick={() => handleUpdateTaxonomy(elem, 'active')}>
                                  <i className="fas fa-trash-alt text-danger m-1 pe-3" />
                                  {elem?.deleted ? 'Undelete' : 'Delete'}
                                </DropdownItem> */}
                                {!elem?.userId && (
                                  <>
                                    <Divider className="my-2" />
                                    <DropdownItem onClick={() => handleCreateUser(elem)}>
                                      <i className="fas fa-user-alt text-info m-1 pe-3" />
                                      Create User
                                    </DropdownItem>
                                  </>
                                )}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <TableError />
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>

      <Paginate pageInfo={doctorsPagination} onChangePage={handleChangePage} />
    </div>
  );
};

export default SchoolClinicDoctors;
